// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tree-children[data-v-747077d6] {
  margin-left: 1rem;
}
.tree-children ul[data-v-747077d6] {
  display: block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.tree-children li[data-v-747077d6] {
  white-space: nowrap;
}
ul.tree-node[data-v-747077d6] {
  display: block;
  padding-left: 0.8rem;
}
.toggle-icon[data-v-747077d6] {
  display: inline-block;
  width: 20px;
}
.add-neighbours[data-v-747077d6] {
  cursor: pointer;
}
ul.tree-node[data-v-747077d6]:hover:before {
  background: rgba(190, 235, 255, 0.3);
}
ul span[data-v-747077d6] {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
ul span[data-v-747077d6]:before {
  display: inline-block;
  height: 21px;
}
.hidden[data-v-747077d6] {
  display: none;
}
.tree-text .name[data-v-747077d6] {
  max-width: 70%;
  display: inline-flex;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/renderers/neighbours-view-renderer/neighbour-item.vue"],"names":[],"mappings":"AACA;EACE,iBAAA;AAAF;AACE;EACE,cAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;AACJ;AACE;EACE,mBAAA;AACJ;AAGA;EACE,cAAA;EACA,oBAAA;AAAF;AAGA;EACE,qBAAA;EACA,WAAA;AAAF;AAGA;EACE,eAAA;AAAF;AAGA;EACE,oCAAA;AAAF;AAGA;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AAAF;AAGA;EACE,qBAAA;EACA,YAAA;AAAF;AAGA;EACE,aAAA;AAAF;AAGA;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;AAAF","sourcesContent":["\n.tree-children {\n  margin-left: 1rem;\n  ul {\n    display: block;\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n  }\n  li {\n    white-space: nowrap;\n  }\n}\n\nul.tree-node {\n  display: block;\n  padding-left: .8rem;\n}\n\n.toggle-icon {\n  display: inline-block;\n  width: 20px;\n}\n\n.add-neighbours {\n  cursor: pointer;\n}\n\nul.tree-node:hover:before {\n  background: rgba(190, 235, 255, 0.3);\n}\n\nul span {\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\nul span:before {\n  display: inline-block;\n  height: 21px;\n}\n\n.hidden {\n  display: none;\n}\n\n.tree-text .name {\n  max-width: 70%;\n  display: inline-flex;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
